module.exports = __webpack_public_path__ + "static/media/icon-payment-error.c0100d9a.svg";